import { SVGProps, Ref, forwardRef } from 'react';

export const MetroStationSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <circle cx={8} cy={8} r={3.333} fill="currentColor" />
    </svg>
));
MetroStationSize16Glyph.displayName = 'MetroStationSize16Glyph';
